import { DeviceService } from '../shared/services/device.service';
import {
    IControlInput, IDeviceInformation, IDeviceItemGrouping, IDeviceItemVisitor,
    IDeviceNode, IDynamicControlsSharedState
} from '../shared/models/device';

/**
 * Disable children of disabled nodes -- even if they are individually set to be enabled the parent should override
 */
export class IsEnabledVisitor implements IDeviceItemVisitor {
    public currentGrouping: IDeviceItemGrouping;
    public service: DeviceService;
    private sharedState: IDynamicControlsSharedState;

    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState
    ) {
        this.sharedState = sharedState;
    }

    public canVisit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): boolean {
        let controlInput = owningObject as IControlInput;

        let canVisit = (typeof controlInput.isEnabled !== 'undefined') && !controlInput.isEnabled;

        return canVisit;
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {
        let controlInput = propValue as IControlInput;

        controlInput.isEnabled = false;

        return null;
    }
}
